import {DefaultTheme} from 'styled-components';
import {mix, rgba} from 'polished';

import {ice, chambray, tango, mineshaft, gallery, white} from '../colors';

export const Theme: DefaultTheme = {
    svg: {
        authors: {
            backgroundColor: ice,
            foregroundColor: rgba(chambray, 0.2)
        }
    },
    color: {
        primary: mineshaft,
        secondary: tango,
        foreground: mineshaft,
        background: gallery,
        label: mix(0.4, mineshaft, white)
    },
    font: {
        family: {
            primary: '"Baton Turbo", sans-serif',
            secondary: '"Baton Turbo Book", sans-serif'
        },
        weight: {
            normal: 400,
            bold: 600,
            heavy: 900
        }
    },
    breakpoint: {
        desktop: '1144px'
    }
};
